/* eslint-disable */
import { Middleware } from "@sa/rep-common";
import { DataFlowProcessingState } from "@sa/rep-core";
import { REPORT_ID, REPORT_APE_ID } from '../constants';

export const report9DataflowMiddlewares: Middleware<DataFlowProcessingState> = (input, next) => {
  if (input.reportId === REPORT_ID) {
    for (const key of input.parameters.keys()) {
      // if (key === "@calendar") {
      //   const val = input.parameters.get(key) as any;
      //   const cropValue = [val[val.length - 2], val[val.length - 1]]
      //   input.parameters.set("@crop_calendar", cropValue);
      // }
    }
  }
  return next(input);
};
